export default "__VITE_ASSET__BZOkBoKV__"